module.exports = __webpack_public_path__ + "static/axe-in-stump-dbe23443d7c579befff281756d3c3018.jpeg";